import React from 'react';
import ContentLoader from 'react-content-loader';

const Loader = () => {
    return (
        <ContentLoader
            speed={2}
            width={966}
            height={87}
            viewBox="0 0 966 87"
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb">
            <>
                <rect x="0" y="8" rx="3" ry="3" width="95" height="10" />
                <rect x="0" y="28" rx="3" ry="3" width="260" height="40" />

                <rect x="278" y="8" rx="3" ry="3" width="50" height="10" />
                <rect x="278" y="28" rx="3" ry="3" width="130" height="40" />

                <rect x="428" y="8" rx="3" ry="3" width="28" height="10" />
                <rect x="428" y="28" rx="3" ry="3" width="130" height="40" />

                <rect x="578" y="8" rx="3" ry="3" width="28" height="10" />
                <rect x="578" y="28" rx="3" ry="3" width="130" height="40" />

                <rect x="728" y="8" rx="3" ry="3" width="74" height="10" />
                <rect x="728" y="28" rx="3" ry="3" width="90" height="40" />

                <rect x="838" y="8" rx="3" ry="3" width="135" height="10" />
                <rect x="838" y="28" rx="3" ry="3" width="130" height="40" />
            </>
        </ContentLoader>
    );
};

export default Loader;
